/**
 * @generated SignedSource<<5a24faa330b20a050fa3602edb00c796>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type header_projectsDirectoryV3$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"createProjectAction_projectsDirectoryV3_CreateButton" | "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton">;
  } | null | undefined;
  readonly " $fragmentType": "header_projectsDirectoryV3";
};
export type header_projectsDirectoryV3$key = {
  readonly " $data"?: header_projectsDirectoryV3$data;
  readonly " $fragmentSpreads": FragmentRefs<"header_projectsDirectoryV3">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAnonymous"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectListSidebarExperimentEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "header_projectsDirectoryV3",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "createProjectAction_projectsDirectoryV3_CreateButton"
        },
        {
          "condition": "isProjectListSidebarExperimentEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "condition": "isAnonymous",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "3f0e35d181db6e5a44c60622c6033dc4";

export default node;
